module.exports = __webpack_public_path__ + "01_hair_gold.324098b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/01_hair_gold.png
// module id = LhXz
// module chunks = 0